import { userErrorMessage } from '../api/client';

export function Spinner({ text = '読み込み中...' }: { text?: string }) {
  return (
    <div className="flex items-center gap-2 justify-center py-8 text-muted">
      <div className="w-5 h-5 border-2 border-slate-300 border-t-primary rounded-full animate-spin" />
      <span className="text-sm">{text}</span>
    </div>
  );
}

export function ErrorBox({ error }: { error: Error }) {
  return (
    <div className="bg-red-50 border border-red-200 text-danger p-4 rounded">
      エラー: {userErrorMessage(error)}
    </div>
  );
}
